import React, { useEffect, useState } from 'react';
import axios from 'axios';
import HeadRegresar from "../../sharecomponents/HeadRegresar";
import { API_URL } from "../../../utils/Common";

const initFrmLabores = Object.freeze({
    labor: ''
});

const initform = Object.freeze({
    laborid: '0',
    proceso: 'Ninguno',
    sinicial: '0',
    sfinal: '0'
});

const LaboresFlor = props => {
    const florId = props.match.params.id;

    const [frmVarcolLab, setFrmVarcolLab] = useState(initform);
    const [frmLabores, setFrmLabores] = useState(initFrmLabores);
    const [labores, setLabores] = useState([]);
    const [catLbores, setCatLabores] = useState([]);
    const [infoFlor, updateInfoFlor] = useState(null);

    useEffect(() => {
        axios
            .get(API_URL + "/flor/getFlor?id=" + florId)
            .then((r) => {
                updateInfoFlor(r.data);
            })
            .catch((err) => console.log(err));
        getLabores();
        getLaboresVarcolor();
    }, [florId])

    //region variedad-color-labor
    const getLaboresVarcolor = () => {
        axios.get(API_URL + '/flor/getVarcolorLabores', { params: { florId } })
            .then(r => {
                setLabores(r.data.labores);
            })
            .catch(e => console.log(e));
    }

    const submit = (e) => {
        e.preventDefault();
        axios.post(API_URL + '/flor/setvarcolorlabor', { ...frmVarcolLab, florId })
            .then(r => {
                setFrmVarcolLab(initform);
                getLaboresVarcolor();
            })
            .catch(e => console.log(e));
    }

    const onchange = (e) => {
        setFrmVarcolLab({
            ...frmVarcolLab,
            [e.target.name]: e.target.value
        });
    }

    const remFlorLabor = (l) => {
        axios.post(API_URL + '/remFlorLabor', { florId, id: l.laborId })
            .then(r => {
                getLaboresVarcolor();
            })
            .then(e => console.log(e));
    }
    //endregion

    //region -- Labores
    const handleChLab = (e) => {
        setFrmLabores({
            ...frmLabores,
            [e.target.name]: e.target.value
        });
    }

    const getLabores = () => {
        axios.get(API_URL + '/flor/getlabores')
            .then(r => {
                setCatLabores(r.data.labores);
            });
    }

    const submitLabores = (e) => {
        e.preventDefault();
        axios.post(API_URL + '/flor/setlabor', { ...frmLabores })
            .then(r => {
                setFrmLabores(initFrmLabores);
                getLabores();
            })
            .catch(e => console.log(e));
    }
    //endregion

    return (
        <div className="w-full p-3 right-0">
            <div className="bg-white border rounded shadow-xl">
                <div className="border-b rounded-t p-3 bg-orange-900">
                    <HeadRegresar
                        titulo={infoFlor ? `Configuración de las Labores de ${infoFlor.tipoFlor[0].flor} ${infoFlor.tipoFlor[0].variedad} ${infoFlor.tipoFlor[0].color}` : ""}
                        history={props.history} />
                </div>
                <div className="p-5 rounded-b">
                    {/* ---- CONTENIDO --- */}
                    <div className="text-sm flex flex-wrap -mx-3 mb-6">
                        <div className="w-2/3 px-3">
                            <h3 className="text-orange-900 font-bold border-b-2 border-orange-700 py-1 pl-1 mb-2">
                                Configuración Labores
                            </h3>
                            <form onSubmit={submit}>
                                <div className="text-sm flex flex-wrap -mx-3 mb-6">
                                    <div className="w-1/4 px-3">
                                        <label
                                            className="block tracking-wide text-gray-700 font-bold mb-2">Labor:</label>
                                        <div className="relative">
                                            <select
                                                className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                name="laborid"
                                                id="laborid"
                                                value={frmVarcolLab.laborid}
                                                onChange={onchange}
                                            >
                                                <option value="0">Ninguno</option>
                                                {catLbores.map((l, i) => {
                                                    return (
                                                        <option key={i} value={l.id}>
                                                            {l.labor}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                            <div
                                                className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 20 20">
                                                    <path
                                                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    {/** a que proceso se hará la actividad */}
                                    <div className="w-1/4 px-3">
                                        <label className="block tracking-wide text-gray-700 font-bold mb-2">
                                            Proceso:
                                        </label>
                                        <div className="relative">
                                            <select
                                                className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                name="proceso"
                                                value={frmVarcolLab.proceso}
                                                onChange={onchange}
                                            >
                                                <option value="Ninguno">Ninguno</option>
                                                <option value="Propagacion">Propagación</option>
                                                <option value="Campo">Campo</option>
                                            </select>
                                            <div
                                                className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 20 20">
                                                    <path
                                                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-1/4 px-3">
                                        <label className="block tracking-wide text-gray-700 font-bold mb-2">Semana
                                            Inicial:</label>
                                        <input
                                            className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                            type="number"
                                            step="any"
                                            name="sinicial"
                                            value={frmVarcolLab.sinicial}
                                            onChange={onchange}
                                            onFocus={(e) => e.target.select()}
                                        />
                                    </div>
                                    <div className="w-1/4 px-3">
                                        <label className="block tracking-wide text-gray-700 font-bold mb-2">Semana
                                            Final:</label>
                                        <input
                                            className="text-right text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                            type="number"
                                            step="any"
                                            name="sfinal"
                                            value={frmVarcolLab.sfinal}
                                            onChange={onchange}
                                            onFocus={(e) => e.target.select()}
                                        />
                                    </div>
                                </div>
                                <button
                                    className="text-sm bg-orange-800 hover:bg-orange-700 text-white py-2 px-3 rounded shadow focus:outline-none"
                                    type="submit"
                                >
                                    Guardar
                                </button>
                            </form>
                            <div className="w-full overflow-x-scroll shadow-xl mt-5">
                                <table className="mb-2">
                                    <thead>
                                        <tr className="text-sm text-white content-center bg-orange-800">
                                            <th className="bg-white border-white border-l-0 border-t-0"></th>
                                            <th className="border border-orange-800">Labor</th>
                                            {
                                                [...Array(20)].map((x, i) => {
                                                    return (
                                                        <th className="border border-orange-800 px-1"
                                                            key={i}>{"Sem " + (i + 1)}</th>
                                                    )
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            labores.map((l, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td className="border px-4 py-2">
                                                            <button
                                                                className="px-1 py-1 focus:outline-none"
                                                                onClick={() => remFlorLabor(l)}>
                                                                <i className="far fa-trash-alt" />
                                                            </button>
                                                        </td>
                                                        <td className="border px-4 py-2">
                                                            {l.labor} <br />
                                                            {l.proceso != '' && <span
                                                                className="text-sm font-bold text-orange-800">[{l.proceso}]</span>}
                                                        </td>
                                                        {
                                                            l.semanas.map((s, j) => {
                                                                return (
                                                                    <td className={s === 'A' ? "border px-4 py-2 bg-green-100" : "border px-4 py-2"}
                                                                        key={j}>{s}</td>
                                                                )
                                                            })
                                                        }
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="w-1/3 px-3">
                            <h3 className="text-orange-900 font-bold border-b-2 border-orange-700 py-1 pl-1 mb-2">
                                Catálogo de Labores
                            </h3>
                            {/** formulario de labores **/}
                            <form onSubmit={submitLabores}>
                                <div className="flex flex-wrap -mx-3 mb-6">
                                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                        <input
                                            className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                            name="labor"
                                            type="text"
                                            placeholder="labor..."
                                            value={frmLabores.labor}
                                            onChange={handleChLab}
                                        />
                                    </div>
                                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                        <button
                                            className="text-sm bg-orange-800 hover:bg-orange-700 text-white py-2 px-3 rounded shadow focus:outline-none"
                                            type="submit"
                                        >
                                            Guardar
                                        </button>
                                    </div>
                                </div>
                            </form>
                            {/** ./formulario de labores **/}
                            {/** tabla de labores **/}
                            <table className="mb-3">
                                <thead>
                                    <tr className="border border-orange-800 text-sm text-white content-center bg-orange-800">
                                        <th className="w-auto px-1 py-1">No</th>
                                        <th className="w-auto px-1 py-1">Labores</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        catLbores.map((l, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td className="border px-4 py-2">{i + 1}</td>
                                                    <td className="border px-4 py-2">{l.labor}</td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                            {/** ./tabla de labores **/}
                        </div>

                    </div>
                    {/* ---- ./CONTENIDO --- */}
                </div>
            </div>
        </div>
    )
}

export default LaboresFlor;
